import { SessionsConsolePage } from "../../operator/console/sessions-console";
export default function ConsoleSessionsListRoute() {
  return <SessionsConsolePage />;
}
